export default {"src":"/_next/static/media/tourismlogo2.2eb0c99a.svg","height":40,"width":304,"blurWidth":0,"blurHeight":0};